import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    home: 'Home',
    restaurants: 'Restaurants',
    shisha: 'Shisha',
    services: 'Services',
    orders: 'My Orders',
    profile: 'Profile',
    login: 'Login',
    logout: 'Logout',
    admin: 'Admin',
    driver: 'Driver',
    
    // Hero
    heroTitle: 'Food and services delivered anywhere in Tróia',
    heroSubtitle: 'Order food and services in Tróia. Delivered in minutes.',
    viewRestaurants: 'View Restaurants',
    rentShisha: 'Rent Shisha',
    exploreServices: 'Explore Services',
    
    // Restaurant
    deliveryTime: 'Delivery time',
    minOrder: 'Min. order',
    deliveryFee: 'Delivery fee',
    deliveryFrom: 'Delivery from €5.00',
    fromPrefix: 'From',
    menu: 'Menu',
    addToCart: 'Add to Cart',
    popular: 'Popular',
    
    // Cart
    cart: 'Cart',
    emptyCart: 'Your cart is empty',
    subtotal: 'Subtotal',
    total: 'Total',
    checkout: 'Checkout',
    continueShopping: 'Continue Shopping',
    
    // Checkout
    customerInfo: 'Customer Information',
    name: 'Name',
    phone: 'Phone',
    deliveryLocation: 'Delivery Location',
    locationType: 'Location Type',
    hotelName: 'Hotel/Apartment Name',
    roomNumber: 'Room Number',
    paymentMethod: 'Payment Method',
    placeOrder: 'Place Order',
    notes: 'Notes',
    
    // Location types
    hotel: 'Hotel',
    apartment: 'Apartment',
    beach: 'Beach',
    marina: 'Marina',
    residential: 'Residential',
    
    // Payment methods - removed stripe card option, keeping only transfer options
    cash: 'Cash on Delivery',
    mbway: 'MBWay',
    applePay: 'Apple Pay',
    card: 'Card (Bank Transfer)',
    
    // Order status
    orderReceived: 'Order Received',
    preparing: 'Preparing',
    readyForPickup: 'Ready for Pickup',
    outForDelivery: 'Out for Delivery',
    delivered: 'Delivered',
    
    // Shisha
    selectModel: 'Select Model',
    selectFlavor: 'Select Flavor',
    rentalDuration: 'Rental Duration',
    extras: 'Extras',
    extraCharcoal: 'Extra Charcoal',
    extraHose: 'Extra Hose',
    deliveryTime: 'Delivery Time',
    rentNow: 'Rent Now',
    hours: 'hours',
    deposit: 'Deposit',
    
    // Beach Mode
    beachMode: 'Beach Mode',
    beachModeActive: 'Beach Mode Active',
    deliveryAvailable: 'Delivery available in your area',
    
    // General
    loading: 'Loading...',
    error: 'Something went wrong',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    comingSoon: 'Coming Soon',
    
    // Auth
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    register: 'Register',
    loginWithGoogle: 'Continue with Google',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    
    // Admin
    dashboard: 'Dashboard',
    manageRestaurants: 'Manage Restaurants',
    manageOrders: 'Manage Orders',
    manageDrivers: 'Manage Drivers',
    settings: 'Settings',
    statistics: 'Statistics',
    revenue: 'Revenue',
    todayOrders: 'Today Orders',
    totalOrders: 'Total Orders',
    pendingOrders: 'Pending Orders',
  },
  pt: {
    // Navigation
    home: 'Início',
    restaurants: 'Restaurantes',
    shisha: 'Shisha',
    services: 'Serviços',
    orders: 'Meus Pedidos',
    profile: 'Perfil',
    login: 'Entrar',
    logout: 'Sair',
    admin: 'Admin',
    driver: 'Entregador',
    
    // Hero
    heroTitle: 'Comida e serviços entregues em qualquer lugar de Tróia',
    heroSubtitle: 'Peça comida e serviços em Tróia. Entregue em minutos.',
    viewRestaurants: 'Ver Restaurantes',
    rentShisha: 'Alugar Shisha',
    exploreServices: 'Explorar Serviços',
    
    // Restaurant
    deliveryTime: 'Tempo de entrega',
    minOrder: 'Pedido mín.',
    deliveryFee: 'Taxa de entrega',
    deliveryFrom: 'Entrega a partir de €5,00',
    fromPrefix: 'A partir de',
    menu: 'Cardápio',
    addToCart: 'Adicionar',
    popular: 'Popular',
    
    // Cart
    cart: 'Carrinho',
    emptyCart: 'Seu carrinho está vazio',
    subtotal: 'Subtotal',
    total: 'Total',
    checkout: 'Finalizar',
    continueShopping: 'Continuar Comprando',
    
    // Checkout
    customerInfo: 'Informações do Cliente',
    name: 'Nome',
    phone: 'Telefone',
    deliveryLocation: 'Local de Entrega',
    locationType: 'Tipo de Local',
    hotelName: 'Nome do Hotel/Apartamento',
    roomNumber: 'Número do Quarto',
    paymentMethod: 'Método de Pagamento',
    placeOrder: 'Fazer Pedido',
    notes: 'Observações',
    
    // Location types
    hotel: 'Hotel',
    apartment: 'Apartamento',
    beach: 'Praia',
    marina: 'Marina',
    residential: 'Residencial',
    
    // Payment methods
    cash: 'Dinheiro na Entrega',
    mbway: 'MBWay',
    applePay: 'Apple Pay',
    stripe: 'Cartão (Stripe)',
    
    // Order status
    orderReceived: 'Pedido Recebido',
    preparing: 'Preparando',
    readyForPickup: 'Pronto para Recolha',
    outForDelivery: 'Saiu para Entrega',
    delivered: 'Entregue',
    
    // Shisha
    selectModel: 'Selecionar Modelo',
    selectFlavor: 'Selecionar Sabor',
    rentalDuration: 'Duração do Aluguer',
    extras: 'Extras',
    extraCharcoal: 'Carvão Extra',
    extraHose: 'Mangueira Extra',
    deliveryTime: 'Horário de Entrega',
    rentNow: 'Alugar Agora',
    hours: 'horas',
    deposit: 'Depósito',
    
    // Beach Mode
    beachMode: 'Modo Praia',
    beachModeActive: 'Modo Praia Ativo',
    deliveryAvailable: 'Entrega disponível na sua área',
    
    // General
    loading: 'Carregando...',
    error: 'Algo deu errado',
    success: 'Sucesso',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Salvar',
    edit: 'Editar',
    delete: 'Excluir',
    search: 'Pesquisar',
    filter: 'Filtrar',
    all: 'Todos',
    comingSoon: 'Em Breve',
    
    // Auth
    email: 'Email',
    password: 'Senha',
    confirmPassword: 'Confirmar Senha',
    register: 'Cadastrar',
    loginWithGoogle: 'Continuar com Google',
    noAccount: 'Não tem uma conta?',
    haveAccount: 'Já tem uma conta?',
    
    // Admin
    dashboard: 'Painel',
    manageRestaurants: 'Gerenciar Restaurantes',
    manageOrders: 'Gerenciar Pedidos',
    manageDrivers: 'Gerenciar Entregadores',
    settings: 'Configurações',
    statistics: 'Estatísticas',
    revenue: 'Faturamento',
    todayOrders: 'Pedidos Hoje',
    totalOrders: 'Total de Pedidos',
    pendingOrders: 'Pedidos Pendentes',
  }
};

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'pt';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'pt' : 'en');
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t,
    isEnglish: language === 'en',
    isPortuguese: language === 'pt'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
